import React from 'react'
import PropTypes from "prop-types";
import { Link, useNavigate } from 'react-router-dom';
import { Alert, Card, CardBody, Col, Container, FormFeedback, Input, Label, Row } from 'reactstrap';
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";
import { useDispatch } from 'react-redux';
import withRouter from 'components/Common/withRouter';
// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from '../../components/Common/ApiManagement/apiServices';
import { handleErrors, showToaster } from "components/Common/common";

// action
import { userForgetPassword } from "../../store/actions";
import { PAGEPATHS } from 'components/Common/Constant';



const ForgetPasswordPage = props => {
  document.title = "Forget Password | Lexa - Responsive Bootstrap 5 Admin Dashboard";

  const dispatch = useDispatch();
    const navigate = useNavigate()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      // dispatch(userForgetPassword(values, props.history));
      handleSubmit(values);
    }
  });

  const handleSubmit = async(values)=>{
    try {
      const postForm = {
        email : values.email
      }

      const {data} = await axiosInstance.post(ApiNames.USER_FORGOTPASS, postForm);    
      if (data) {
                showToaster(data.status, data.message);               
              }
    } catch (error) {
            handleErrors(error);
    }
  }

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  <h3 className="text-center mt-5 mb-4">
                    <Link to="/" className="d-block auth-logo">
                      <img src={logoDark} alt="" height="30" className="auth-logo-dark" />
                      <img src={logoLight} alt="" height="30" className="auth-logo-light" />
                    </Link>
                  </h3>
                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-3 text-center">Reset Password</h4>
                    <form className="form-horizontal mt-4"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}>

                      <div className="mb-3">
                        <Label htmlFor="useremail">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="d-flex items-center justify-between flex-col-reverse md:flex-row gap-3">
                        <p className="m-0">Remember it ? <Link to={PAGEPATHS.Login} className="text-primary"> Sign in here. </Link> </p>
                        <div className="text-start">
                        <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
              © {new Date().getFullYear()} <span className="d-none d-sm-inline-block"> - Bravent </span>
              </div>
            </Col>
          </Row>
        </Container>
      </div>


    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
